import type { Xinglet } from '@xing-com/crate-xinglet';

import type { JobMetadataProps } from './components';
import { JobMetadata } from './components';

export default class JobMetadataXinglet implements Xinglet {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public getComponent(): React.ComponentType<JobMetadataProps> {
    return (props) => <JobMetadata {...props} />;
  }
}
